import React, { useEffect, useState } from "react";
import "./LessonAssignmentAnalyticsTab.css";
import AssignmentViewProgress from "../AssignmentViewProgress";
import { useLocation, useNavigate } from "react-router";
import api, { liveBaseURL, wsURL } from "../../../src/api/api";
import { useAuth } from "../../features/auth/AuthContext";
import BackButton from "../BackButton/BackButton";
import Helper from "../../utils/Helper";

function LessonAssignmentAnalyticsTab() {
    const { token } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();




    // function LessonAssignmentAnalyticsTab() {
    const [activeTab, setActiveTab] = useState("assignments"); // Default active tab is 'lessons'
    const [showDropdown, setShowDropdown] = useState(false);
    const [assignmentList, setAssignmentList] = useState([]);
    const [selectedAssignment, setSelectedAssignment] = useState({
        name: null,
        id: null,
        end_date: null,
        start_date: null,
    });


    const courseType = location.state.course_type;
    const type = location?.state?.course?.type


 
    useEffect(() => {
        if (location.state === null) {
            navigate("/dashboard/home");
            return;
        }

        if (
            location.state.assignment_id &&
            location.state.assignment_name &&
            location.state.assignment_start_date
        ) {
            setSelectedAssignment({
                name: location.state.assignment_name,
                id: location.state.assignment_id,
                end_date: location.state.assignment_end_date,
                start_date: location.state.assignment_start_date,
            });
        }
    }, []);

  
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === "assignments") {
            setShowDropdown(!showDropdown);
        } else {
            setShowDropdown(false);
        }
    };

    const getAssignmentList = async (lesson_id) => {

        const endpoint =
            (courseType === 1 || type === 1)
                ? `assignment/get-lesson-by-assignments/${lesson_id}/`
                : `/competitive/assignment/get-lesson-by-assignments/${lesson_id}/`;

        await api
            .get(endpoint, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            })
            .then((response) => {
                if (response.data.status === 200) {
                    setAssignmentList(response.data.data);
                    const assignmentdetails = JSON.parse(localStorage.getItem(
                        "assignmentanalyticsdetails"
                    ));
                    if (assignmentdetails) {
                        setSelectedAssignment({
                            name: assignmentdetails.name,
                            id: assignmentdetails.id,
                            end_date: assignmentdetails.end_date,
                            start_date: assignmentdetails.start_date,
                        });
                    } else {
                        if (
                            location.state.assignment_id &&
                            location.state.assignment_name &&
                            location.state.assignment_start_date
                        ) {
                            setSelectedAssignment({
                                name: location.state.assignment_name,
                                id: location.state.assignment_id,
                                end_date: location.state.assignment_end_date,
                                start_date: location.state.assignment_start_date,
                            });
                        } else {
                            setSelectedAssignment({
                                name: response.data.data[0].name,
                                id: response.data.data[0].assignment_id,
                                end_date: response.data.data[0].end_date,
                                start_date: response.data.data[0].start_date,
                            });
                        }
                    }
                }
            })
            .catch((error) => { });
    };

    useEffect(() => {
        if (location.state === null) {
            navigate("/dashboard/home");
            return;
        }
        getAssignmentList(location?.state?.lesson?.lesson_id);
    }, []);

    const handleDropdownClick = (e) => {
        e.stopPropagation(); // Prevents the dropdown from closing when clicking inside it
    };



    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="LessonViewProgress-header-section">
                        <div className="view-course-Details-back-btn-folder LessonViewProgress-back-btn-folder">
                            <BackButton buttonName={location?.state?.lesson?.name} />
                        </div>
                        <div className="date-inner-wrapper">
                            <div className="view-course-details-container">
                                <div className="view-Students-course-details-folder LessonViewProgress-student-course-folder">
                                    <span>Created</span>
                                    <div className="view-Students-course-details-counts">
                                        <p>
                                            {
                                                Helper.formatDateTime(
                                                    location?.state?.lesson?.start_date
                                                ).date
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lesson-assignment-analyticsTab-section">
                        <div className="lesson-assignment-analyticsTab-wrapper">
                            <div className="view-lessons-wrapper">
                                <div className="view-lessons-btn-container teacehr-tab-setion">
                                    <div className="dropdown-container">
                                        <button
                                            className={`tab-button ${activeTab === "assignments" ? "active" : ""}`}
                                            onClick={() => handleTabClick("assignments")}
                                        >
                                            {/* {selectedAssignment ? (
                                                `Assignment: ${selectedAssignment?.name?.length > 14 ? selectedAssignment?.name?.substring(0, 14) + '...' : selectedAssignment?.name}`
                                            ) : (
                                                'Assignment Analytics'
                                            )} */}
                                            {selectedAssignment ? (
                                                `Assignment: ${selectedAssignment?.name ? (
                                                    selectedAssignment?.name?.length > 14
                                                        ? selectedAssignment?.name?.substring(0, 14) + '...'
                                                        : selectedAssignment?.name
                                                ) : '0'}`
                                            ) : (
                                                'Assignment Analytics'
                                            )}
                                            <span className="dropdown-icon">{showDropdown ? '▲' : '▼'} </span>
                                        </button>
                                        {showDropdown && assignmentList.length > 0 && (
                                            <div
                                                className="lesson-assignment-analyticsTab-dropdown-menu"
                                                onClick={handleDropdownClick}
                                            >
                                                {assignmentList.map((assignment, index) => {
                                                    return (
                                                        <button
                                                            key={index}
                                                            className="dropdown-item"
                                                            onClick={() => {
                                                                setSelectedAssignment({
                                                                    name: assignment.name,
                                                                    id: assignment.assignment_id,
                                                                    end_date: assignment.end_date,
                                                                    start_date: assignment.start_date,
                                                                });
                                                                setShowDropdown(false);
                                                            }}
                                                        >
                                                            Assignment <span>{index + 1}</span> :{" "}
                                                            {assignment.name.length > 14
                                                                ? assignment.name.substring(0, 14) + "..."
                                                                : assignment.name}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="tab-content">
                                {activeTab === "assignments" && (
                                    <AssignmentViewProgress
                                        selectedAssignment={selectedAssignment}
                                        assignmentList={assignmentList}
                                        courseType={courseType}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LessonAssignmentAnalyticsTab;
